var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.GRICode"),
                                    prop: "fiveBitCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fiveBitCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fiveBitCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.fiveBitCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("material.fiveBitCodeName"),
                                    prop: "fiveBitCodeName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fiveBitCodeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fiveBitCodeName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "queryCondition.fiveBitCodeName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("common.status"),
                                    prop: "status",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      table: "TM_FIVE_BIT_CODE",
                                      field: "STATUS",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.queryCondition.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Category1",
                                    prop: "categoryLevel1Id",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeCategory1()
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.queryCondition.categoryLevel1Id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "categoryLevel1Id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.categoryLevel1Id",
                                      },
                                    },
                                    _vm._l(
                                      _vm.categoryList1,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.tmCategoryId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Category2",
                                            prop: "categoryLevel2Id",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.changeCategory2()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .categoryLevel2Id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "categoryLevel2Id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.categoryLevel2Id",
                                              },
                                            },
                                            _vm._l(
                                              _vm.categoryList2,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.tmCategoryId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Category3",
                                            prop: "categoryLevel3Id",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .categoryLevel3Id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "categoryLevel3Id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.categoryLevel3Id",
                                              },
                                            },
                                            _vm._l(
                                              _vm.categoryList3,
                                              function (item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.tmCategoryId,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.queryData(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _vm.griAdd
            ? _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addGRI()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.newBuilt")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.GRI_COOK_CONFIG,
                  expression: "GRI_COOK_CONFIG",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.onCook },
            },
            [_vm._v("烹饪方式维护")]
          ),
          _vm.griDelete
            ? _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.telGRI()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.del")))]
              )
            : _vm._e(),
          _vm.griDownload
            ? _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.download },
                },
                [_vm._v(_vm._s(_vm.$t("common.download")) + " ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableList",
          attrs: {
            data: _vm.tableList,
            "row-key": "tmFiveBitCodeId",
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              sortable: "",
              type: "selection",
              width: "55",
              align: "center",
              "reserve-selection": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fiveBitCode",
              label: _vm.$t("material.GRICode"),
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(scope.row.tmFiveBitCodeId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.fiveBitCode))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "categoryLevel1Name",
              label: _vm.$t("material.categoryLevel1Name"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "categoryLevel2Name",
              label: _vm.$t("material.categoryLevel2Name"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "categoryLevel3Name",
              label: _vm.$t("material.categoryLevel3Name"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fiveBitCodeName",
              label: _vm.$t("material.fiveBitCodeName"),
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "describe",
              label: _vm.$t("material.describe"),
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "cookNames",
              label: "烹饪方式",
              "min-width": "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createDate",
              label: _vm.$t("common.createDate"),
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("dateFormatFilter")(
                          scope.row.createDate,
                          "YYYY-MM-DD"
                        )
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fromEffectiveDate",
              label: _vm.$t("material.fromEffectiveDate"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "statusI18n", label: "GRI状态", "min-width": "60" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "conductStatusI18n",
              label: "审批状态",
              "min-width": "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "invalidDate",
              label: _vm.$t("material.invalidDate"),
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inventoryCountingFrequency",
              label: _vm.$t("material.inventoryCountingFrequency"),
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "menuTypeI18n",
              label: _vm.$t("material.menuType"),
              "min-width": "70",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "storageCategoryI18n",
              label: _vm.$t("material.storageCategory"),
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "uomI18n", label: "UOM", "min-width": "50" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "standardCopiesUom",
              label: _vm.$t("material.standardCopiesUom"),
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "isDisplayBtrReportI18n",
              label: _vm.$t("material.isDisplayBtrReport"),
              "min-width": "110",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "btrUsageAreaI18n",
              label: _vm.$t("material.btrUsageArea"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "btrUnitMeasurement",
              label: _vm.$t("material.btrUnitMeasurement"),
              "min-width": "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "createUserName",
              label: _vm.$t("common.createBy"),
              "min-width": "80",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "烹饪方式维护",
            visible: _vm.dialogVisible,
            width: "50%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            { ref: "cookForm", attrs: { model: _vm.cookForm } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "GRI编码",
                            prop: "griCode",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.cookForm.griCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.cookForm, "griCode", $$v)
                              },
                              expression: "cookForm.griCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "GRI名称",
                            prop: "griName",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.cookForm.griName,
                              callback: function ($$v) {
                                _vm.$set(_vm.cookForm, "griName", $$v)
                              },
                              expression: "cookForm.griName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "elTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.cookForm.itemList,
                    "row-key": "sortNum",
                    "max-height": "344px",
                    border: "",
                    size: "small",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { "min-width": "60px" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  padding: "1px!important",
                                  backgroundColor: "#f8ab01!important",
                                },
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onAdd(scope.$index, scope.row)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.canOperate &&
                            _vm.cookForm.itemList.length > 1
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { padding: "1px!important" },
                                    attrs: { size: "mini", type: "danger" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDelete(
                                          scope.$index,
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-delete" })]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cookCode",
                      label: "烹饪方式",
                      "render-header": _vm.renderHeader,
                      "min-width": "200px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `itemList.${scope.$index}.cookCode`,
                                  rules: _vm.cookNamesRules(
                                    scope.$index,
                                    scope.row
                                  ),
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TR_NUTR_GRI_COOK",
                                    field: "COOK_CODE",
                                    disabled: !scope.row.canOperate,
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.cookCode,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "cookCode", $$v)
                                    },
                                    expression: "scope.row.cookCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "needInspect",
                      label: "需要检测标识",
                      "render-header": _vm.renderHeader,
                      "min-width": "180px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `itemList.${scope.$index}.needInspect`,
                                  rules: _vm.needInspectRules(
                                    scope.$index,
                                    scope.row
                                  ),
                                },
                              },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TT_NUTR_INGREDIENT",
                                    field: "NEED_INSPECT",
                                    clearable: "",
                                  },
                                  model: {
                                    value: scope.row.needInspect,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "needInspect", $$v)
                                    },
                                    expression: "scope.row.needInspect",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "comments",
                      label: "备注",
                      "min-width": "180px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `itemList.${scope.$index}.comments`,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: "textarea", rows: 1 },
                                  model: {
                                    value: scope.row.comments,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "comments", $$v)
                                    },
                                    expression: "scope.row.comments",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini" },
                  on: { click: _vm.onClose },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }